import React from 'react';
import { Flag, Globe, Landmark, Scale } from 'lucide-react';
import SubjectHub from '@/components/SubjectHub';

// Maps existing curriculum grades to subject hubs.
// Adjust the grades array here if Kansas standards reorganize grade-subject mapping.
export const USHistoryPage = () => (
  <SubjectHub
    testidPrefix="us-history"
    subject={{
      label: 'US History',
      icon: Flag,
      accentColor: '#1D5BAC',
      intro: 'From the founding documents and constitutional debates through the modern American experience — civil rights, foreign policy, and contemporary politics. Pulled from Grade 8 (US History I) and Grade 11 (Modern US History).',
      grades: [8, 11],
    }}
  />
);

export const WorldHistoryPage = () => (
  <SubjectHub
    testidPrefix="world-history"
    subject={{
      label: 'World History',
      icon: Globe,
      accentColor: '#4A6B8A',
      intro: 'Ancient civilizations through the modern globalized world — empires, revolutions, cultural exchange, and 20th-century conflicts. Pulled from Grade 9 (Ancient & Medieval) and Grade 10 (Modern World).',
      grades: [9, 10],
    }}
  />
);

export const CivicsPage = () => (
  <SubjectHub
    testidPrefix="civics"
    subject={{
      label: 'Civics',
      icon: Landmark,
      accentColor: '#7A5C3F',
      intro: 'Rights, participation, and citizenship. Voting, civil liberties, civic responsibility, and the social contract between citizens and the state. Cross-loaded from Grade 7 (Foundations of Government) and Grade 12 (Civics & Government).',
      grades: [7, 12],
    }}
  />
);

export const GovernmentPage = () => (
  <SubjectHub
    testidPrefix="government"
    subject={{
      label: 'Government',
      icon: Scale,
      accentColor: '#7A93AC',
      intro: 'Branches of government, federalism, policy-making, and constitutional law. Anchored in Grade 7 (foundational structures) and Grade 12 (advanced policy & public affairs).',
      grades: [7, 12],
    }}
  />
);
